<div class="dialog-container">
  <div class="head-style">
    <h6 mat-dialog-title class="head-size">
      <span class="head-margin">Cash Counter</span>
    </h6>
    <a class="icon-pos" matTooltip="Close" (click)="onNoClick()">
      <mat-icon >close</mat-icon>
    </a>
  </div>

  <div class="content-area">
    <div class="input-field counterName mb-10">
      <label for="store-select">Selected Cash Counter : &nbsp;&nbsp;</label>
      <label for="store-select">{{ cashCounterName }}</label>
    </div>
    <div class="input-field">
      <label for="store-select">Switch Cash Counter</label>
      <mat-form-field appearance="outline" id="store-select">
        <mat-select [(ngModel)]="cashCounter" required placeholder="Select Cash Counter">
          <mat-option>
            <ngx-mat-select-search [formControl]="cashCounterSearch"
              placeholder="'RegistrationPage.search' | translate"></ngx-mat-select-search>
          </mat-option>
          <mat-option>None</mat-option>
          <mat-option *ngFor="let cashCounter of filterCashCounter" [value]="cashCounter">
            {{cashCounter.cashCounterDesc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button mat-mini-fab (click)="updateCashCounter()" matTooltip="Switch">
    <mat-icon>swap_horiz</mat-icon>
  </button>
  &nbsp;&nbsp;
  <button class="btnOrange" mat-mini-fab (click)="releaseCashcounter()" matTooltip="Release">
    <mat-icon>autorenew</mat-icon>
  </button>
</div>